import React from 'react';
import AdminDashboard from '../AdminDashboard';

const PaymentsPage = () => <AdminDashboard forcedTab="payments" embedded />;

export default PaymentsPage;
